import SiteNavNarrow from "./site-nav-narrow";

const siteNavElements = document.querySelectorAll("[data-site-nav-narrow]");
const siteNavElementsArray = [...siteNavElements];

siteNavElementsArray.forEach(function(element) {
	const options = {
		openButton: document.querySelector(element.dataset.siteNavNarrowOpenButtonSelector),
		closeButton: element.querySelector(element.dataset.siteNavNarrowCloseButtonSelector),
		overlay: document.querySelector(element.dataset.siteNavNarrowOverlaySelector),
		siteHeader: document.querySelector(element.dataset.siteNavNarrowHeaderSelector),
		siteHeaderNarrow: document.querySelector(element.dataset.siteNavNarrowHeaderNarrowSelector),
		siteSearch: document.querySelector(element.dataset.siteNavNarrowSearchSelector),
		openClass: element.dataset.siteNavNarrowOpenClass,
	};

	const instance = new SiteNavNarrow(element, options);
	element.instance = instance;
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/site-nav-narrow/index.js